export const buildRoute = ({
  path,
  params = {},
  hash,
  query,
  full = false,
}: {
  path: string;
  params?: Object;
  hash?: string;
  query?: string;
  full?: boolean;
}) => {
  const keys = Object.keys(params);
  let result = path;
  keys.forEach((key) => {
    result = result.replace(`:${key}`, params[key]);
  });

  if (hash) {
    result += `#${hash}`;
  }

  if (query) {
    if (query.startsWith('?')) {
      query = query.slice(1);
    }

    result += `?${query}`;
  }

  if (full) {
    result = window.location.origin + result;
  }

  return result;
};
